<div>
    <mgp-navbar></mgp-navbar>
</div>
<div class="mgp-container-fluid">
    <router-outlet></router-outlet>
</div>

<div>
    <mgp-footer></mgp-footer>
</div>